<template>
  <div class="va-chat">
    <div
      class="va-chat__body"
      ref="chatBody"
      :style="{'height': height}"
      v-sticky-scroll="{
        animate: true,
        duration: 500
      }"
    >
      <message-bls v-for="message in messages" :key="message.id" :value="message" />
    </div>
    <div class="va-chat__controls">
      <va-input
        v-model="inputMessage"
        @keypress.enter="sendMessage"
        placeholder="Type your message..."
        class="va-chat__input"
      />
      <va-button @click="sendMessage()">
        Send
      </va-button>
    </div>
  </div>
</template>

<script>
import { StickyScroll } from '../../../services/vuestic-ui/components'
import MessageBls from './MessageBls.vue'

export default {
  name: 'chat',
  components: { MessageBls },
  directives: { StickyScroll },
  data () {
    return {
      inputMessage: '',
    }
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    height: {
      default: '20rem',
      type: String,
    },
  },
  methods: {
    sendMessage () {
      if (!this.inputMessage) {
        return
      }
      this.$emit('send-message', { text: this.inputMessage })
      this.inputMessage = ''
    },
  },
  created() {
    this.$nextTick(() => {
      this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight
    })
  },
}
</script>

<style lang='scss'>
.chat {
  &__content {
    @include va-flex-center();
  }
}

$chat-message-br: 0.875rem;

.va-chat {
  width: 100%;

  &__body {
    min-height: 70vh;
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    overflow-y: auto;
  }

  &__message {
    position: relative;
    padding: 0.657rem 1.375rem;
    margin-bottom: 0.625rem;
    max-width: 70%;
    overflow-wrap: break-word;
    border-radius: 0.5rem;
    border-top-left-radius: 0;
    align-self: flex-start;
    background-color: $light-gray2;

    &-text {
      display: block;
      transform: translateY(-2px);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &--yours {
      color: white;
      align-self: flex-end;
      border-top-right-radius: 0;
      border-top-left-radius: 0.5rem;
    }
  }

  &__controls {
    display: flex;
    align-items: center;
  }

  &__input {
    margin-bottom: 0;
  }
}
</style>
